export default "__VITE_ASSET__D5MkoN7Q__"